import LOG from '../logging/Logger'
import { DataStore, Predicates } from '@aws-amplify/datastore'
import { Area, Attachment, Project, Repeat, Tag, Todo } from '../models'

export const getAllTags = async () => {
  LOG.debug('Query backend for all Tags')

  const tags = await DataStore.query(Tag, Predicates.ALL)
  return tags
}

export const getAllAttachments = async () => {
  LOG.debug('Query backend for all Attachments')

  const attachments = await DataStore.query(Attachment, Predicates.ALL)
  return attachments
}

export const getAllTodos = async () => {
  LOG.debug('Query backend for all TODOs')

  const todos = await DataStore.query(Todo, Predicates.ALL)
  return todos
}

export const getAllForeignTodos = async (clientId, callback) => {
  LOG.debug('Query backend for all TODOs not updated by this client')

  DataStore.query(Todo, todo => todo.clientId('ne', clientId)).then(todos =>
    callback(todos)
  )
}

export const getAllProjects = async () => {
  LOG.debug('Query backend for all Projects')

  const projects = await DataStore.query(Project, Predicates.ALL)
  return projects
}

export const getAllAreas = async () => {
  LOG.debug('Query backend for all Areas')

  const areas = await DataStore.query(Area, Predicates.ALL)
  return areas
}

export const getAllRepeats = async () => {
  LOG.debug('Query backend for all Repeats')

  const repeats = await DataStore.query(Repeat, Predicates.ALL)
  return repeats
}

const observe = async (clientId, Type, callback) => {
  LOG.debug('Subscribe to changes')

  const handleRequery = async id => {
    const items = await DataStore.query(Type, c => c.id('eq', id))

    if (items && items.length === 1) {
      return items[0]
    }

    return null
  }

  const subscription = DataStore.observe(Type).subscribe(msg => {
    if (msg.element.clientId && msg.element.clientId !== clientId) {
      if (msg.element instanceof Type) {
        callback(msg.element, msg.opType)
      } else {
        handleRequery(msg.element.id).then(model => {
          if (model) {
            callback(model, msg.opType)
          }
        })
      }
    }
  })

  return () => {
    LOG.debug('Unsubscribing from changes')
    subscription.unsubscribe()
  }
}

export const observeAreas = async (clientId, callback) => {
  observe(clientId, Area, callback)
}

export const observeAttachments = async (clientId, callback) => {
  observe(clientId, Attachment, callback)
}

export const observeProjects = async (clientId, callback) => {
  observe(clientId, Project, callback)
}

export const observeRepeats = async (clientId, callback) => {
  observe(clientId, Repeat, callback)
}

export const observeTags = async (clientId, callback) => {
  observe(clientId, Tag, callback)
}

export const observeTodos = async (clientId, callback) => {
  observe(clientId, Todo, callback)
}

export const saveLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getLocal = key => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    LOG.error(e)
  }
  return null
}
